








import { Component, Vue, Prop } from 'vue-property-decorator';

interface TableConfig {
  type: string,
  label: string,
  key: string,
  align?: string,
  width?: string,
  minWidth?: string,
  showOverflowTooltip?: boolean,
  resizable?: boolean,
  sortable?: boolean,
  fixed?: string | boolean,
  inputType?: string,
  imgWidth?: string | number,
  imgHeight?: string | number,
  tagType?: string,
  radiusable?: boolean,
  list?: any,
  isInput?: boolean,
  columns?: any
}

@Component({
  name: 'muColumnItem'
})
export default class extends Vue {
  @Prop({ default: () => [] }) private config: TableConfig;
}
